import {makeStyles} from '@material-ui/core/styles'
import useImageSlider from './useImageSlider'

const ImageSlider = ({editMode, admin, data, index, formikProps, className}) => {
    if (!data) { data = fakeImageData()}
    const classes = useStyles({editMode})
    const {viewSwitcher} = useImageSlider()

    return (
        <div className={`${classes.root} ${className}`}>
            {viewSwitcher(editMode, admin, data, formikProps, index)}
        </div>

    )
}

const fakeImageData = () => {
    return {
        "cardId": "864a4a5e-a8e3-4a74-be97-bc2e8a345975",
        "label": "Image Slider",
        "sysName": "Card 2",
        "position": 2,
        "type": "Image Slider",
        "isArchived": false,
        "isHidden": false,
        "isMandatory": false,
        "cardData": [
            {
                "fieldId": "72ca7043-def5-4631-bfc9-721683c3a88f",
                "label": "Image Item 1",
                "sysName": "Field 20",
                "position": 0,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "ae55d594-db67-445a-ac91-04af726e3ea1",
                "label": "Image Item 2",
                "sysName": "Field 21",
                "position": 1,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "e6b3c8ee-9c6d-4046-b77b-d0330ce9a4a2",
                "label": "Image Item 3",
                "sysName": "Field 22",
                "position": 2,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "89989edb-190f-4df2-8ab6-29b66767ab62",
                "label": "Image Item 4",
                "sysName": "Field 23",
                "position": 3,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "bffbd572-07d3-41f1-a983-e0873389a60d",
                "label": "Image Item 5",
                "sysName": "Field 24",
                "position": 4,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "a82a9da8-a19d-4902-9c9c-56bb4a2ec06a",
                "label": "Image Item 6",
                "sysName": "Field 25",
                "position": 5,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "632485ab-04e4-422d-a147-f21580d96395",
                "label": "Image Item 7",
                "sysName": "Field 26",
                "position": 6,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "7dd868a8-2089-4670-bf75-08de4364a54c",
                "label": "Image Item 8",
                "sysName": "Field 27",
                "position": 7,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "2cd99d29-d5b3-49f3-a2a3-4f8aa92b6108",
                "label": "Image Item 9",
                "sysName": "Field 28",
                "position": 8,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "e5a12795-28c0-40b0-8041-b37c2c248405",
                "label": "Image Item 10",
                "sysName": "Field 154",
                "position": 9,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "63548a02-6472-4911-9529-c53b4a808a61",
                "label": "Image Item 11",
                "sysName": "Field 155",
                "position": 10,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            },
            {
                "fieldId": "bc19686e-539e-4cc3-992d-6b60301ada2a",
                "label": "Image Item 12",
                "sysName": "Field 156",
                "position": 11,
                "type": "Link",
                "isMandatory": false,
                "isHidden": false,
                "isArchived": false,
                "fieldData": ""
            }
        ]
    }
}

export default ImageSlider

const useStyles = makeStyles((theme)=>({
    root: {
        gridColumn: 'span 4',
        gridRow: 'span 8',
        position: 'relative',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
    },
}))